import {
    AfterContentInit,
    ChangeDetectorRef,
    Component,
    Injector,
    Type,
    ViewChild,
    ViewContainerRef,
    inject,
} from '@angular/core';
import {
    slideInDownOnEnterAnimation,
    slideOutUpOnLeaveAnimation,
} from 'angular-animations';
import { ModalOverlayRef } from '../modal-overlay-ref';
import { ModalConfig } from '../modals.service';

@Component({
    selector: 'serviceos-ng-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss'],
    animations: [
        slideInDownOnEnterAnimation({ duration: 500 }),
        slideOutUpOnLeaveAnimation({ duration: 500 }),
    ],
})
export class PageComponent implements AfterContentInit {
    public visible = false;

    @ViewChild('componentContainer', { read: ViewContainerRef, static: false })
    public componentContainer!: ViewContainerRef;

    public config!: ModalConfig;
    public modalRef!: ModalOverlayRef;
    public contentComponentType!: Type<any>;
    public componentRef: any;

    constructor(
        private readonly cdr: ChangeDetectorRef,
        private readonly injector: Injector
    ) {}

    ngAfterContentInit() {
        this.visible = true;
        setTimeout(() => {
            if (this.componentContainer) this.renderComponent();
        }, 10);
    }

    closeAnimation() {
        this.visible = false;
        this.cdr.detectChanges();
    }

    close(): void {
        this.modalRef.close();
    }

    renderComponent() {
        this.componentContainer?.clear();

        const customInjector = Injector.create({
            providers: [
                { provide: ModalOverlayRef, useValue: this.modalRef },
            ],
            parent: this.injector,
        });

        this.componentRef = this.componentContainer?.createComponent(
            this.contentComponentType,
            {
                injector: customInjector,
            }
        );

        this.cdr.detectChanges();
    }
}
